import React from "react";
import style from "../../styles/components/artistProfile.module.css";
import { getUrl } from "../../hairstylistsData";
import { Image } from "@chakra-ui/react";
import { useWindowDimension } from "./WindowDimension";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
export default function ImagesSlider({ imageArray, obj }) {
  const { height, width } = useWindowDimension();
  const fallbackImages = [
    "https://via.placeholder.com/350",
    "https://via.placeholder.com/350",
    "https://via.placeholder.com/350",
    "https://via.placeholder.com/350",
    "https://via.placeholder.com/350",
  ];
  const imagesLength = imageArray?.length;
  for (let i = 0; i < 5 - imagesLength; i++) {
    imageArray.push(fallbackImages[i]);
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 6,
    },
    tablet: {
      breakpoint: { max: 770, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };
  return (
    <>
      <div className={style.mainimagesRowContainer} style={{}}>
        <Carousel
          responsive={responsive}
          autoPlay={false}
          shouldResetAutoplay={false}
          showDots={false}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          itemClass={style.itemCless}
          infinite={true}
          minimumTouchDrag={10}
          focusOnSelect={true}
        >
          {imageArray?.map((pic, index) => {
            return (
              <div className={style.mobileserviceImgBox} key={index}>
                <Image
                  draggable={false}
                  className={style.serviceImg}
                  src={pic?.startsWith("http") ? pic : getUrl(obj?._id, pic)}
                  alt="img"
                  objectFit="cover"
                />
              </div>
            );
          })}
        </Carousel>
      </div>

      <div
        className={style.imagesRow}
        style={{
          maxHeight:
            width && width < 500
              ? 500
              : !width
              ? imageArray?.length > 5
                ? 2200
                : 1920
              : width,
          position:
            imageArray?.length > 5 || (width && width < 1420)
              ? "absolute"
              : "relative",
        }}
      >
        {imageArray?.map((pic, index) => {
          return (
            <div className={style.serviceImgBox} key={index}>
              <Image
                draggable={false}
                className={style.serviceImg}
                src={pic?.startsWith("http") ? pic : getUrl(obj?._id, pic)}
                alt="img"
                objectFit="cover"
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
